import React, { useState } from 'react';
import { Image } from '@fluentui/react';

interface Props {
    imgSrc: string;
    maxWidth?: number;
    maxHeight?: number;
}

const ImageViewer = ({ imgSrc, maxWidth, maxHeight }: Props) => {
    // 0 - loading, 1 - loaded, 2 - error
    const [loadState, setLoadState] = useState(0);

    return (
        <>
            <Image
                src={imgSrc}
                onLoadingStateChange={(state) => setLoadState(state)}
                style={{
                    maxWidth: 500,
                    maxHeight: 280,
                    cursor: 'pointer',
                    opacity: loadState === 1 ? 1 : 0,
                }}
            />
            {
                loadState === 2 &&
                <div
                    style={{
                        width: 60,
                        height: 60,
                        padding: 10,
                        backgroundColor: "#EEE",
                        color: "#B8B8B8",
                        textAlign: "center"
                    }}
                >
                    Unable to load image
                </div>
            }
            { /*
                loadState === 0 &&
                <Shimmer width="160px" height="120px" style={{ ...styles }} />
            */}
        </>
    );
};

export default ImageViewer;